export default __webpack_public_path__ + "static/media/users-filled.56d768c2.svg";